import ApiBaseService from "./ApiBaseService";

const subscribe = email => {
  return ApiBaseService.post(`/subscription`, {
    email: email
  });
};
export { subscribe };
